module.exports = __webpack_public_path__ + "img/main_bg_04.png";